import PropTypes from 'prop-types'

import CardTooltip from 'components/common/CardTooltip'
import theme from 'theme'

export default function PopoverMenu({ css = {}, getPopoverProps, ...rest }) {
  const { ref: popoverRef, ...propsToApply } = getPopoverProps({
    css: [
      {
        display: 'grid',
        gap: 12,
        minWidth: 180,
        padding: theme.space[3],
        '& .TextButton': { textAlign: 'left' }
      },
      css
    ]
  })

  return <CardTooltip ref={popoverRef} {...propsToApply} {...rest} />
}

PopoverMenu.propTypes = {
  css: PropTypes.any,
  getPopoverProps: PropTypes.func
}
